var map = {
	"./CATARACT_Surgery_AUDIT_FORM.doc": "25cc",
	"./MSF.doc": "34dd",
	"./Refraction_MODEL_EYE_Refraction_part_1_2021-2022.doc": "3821"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "caf4";